import { defineComponent as _defineComponent } from 'vue'
import {ref, watch, nextTick, onMounted, defineProps, defineEmits} from "../TUIKit/adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  TUIUserService,
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import {TUILogin} from "@tencentcloud/tui-core";
import {Toast, TOAST_TYPE} from "../TUIKit/components/common/Toast/index";
import BottomPopup from "../TUIKit/components/common/BottomPopup/index.vue";
import Icon from "../TUIKit/components/common/Icon.vue";
import AboutDialog from "../components/About.vue";
import EditProfileDialog from "../components/EditProfile.vue";
import rightArrowIcon from "../TUIKit/assets/icon/right-icon.svg";
import selectedIcon from "../TUIKit/assets/icon/selected.svg";
import {IUserProfile} from "../TUIKit/interface";
import {isPC} from "../TUIKit/utils/env";
import router from "../router/index";
import {deepCopy} from "../TUIKit/components/TUIChat/utils/utils"


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  props: {
  displayType: {
    type: String,
    default: "profile", // "profile"/"setting"/"all"
  },
  showSetting: {
    type: Boolean,
    default: false,
  },
},
  emits: ["toggleSettingShow"],
  setup(__props, { emit: emits }) {

const props = __props



const settingDomRef = ref();
const userProfile = ref<IUserProfile>({});
const isAboutBoxShow = ref<boolean>(false);
const isEditProfileBoxShow = ref<boolean>(false);
const hideSetting = ref<boolean>(false);
const settingList = ref<{
  [propsName: string]: {
    value: string;
    label: string;
    onClick?: any;
    // children相关
    selectedChild?: string;
    childrenShowType?: string; // "bottomPopup"/"switch"
    showChildren?: boolean;
    children?: {
      [propsName: string]: {
        value: string;
        label: string;
        onClick?: any;
      };
    };
  };
}>({
  editProfile: {
    value: "editProfile",
    label: "编辑资料",
    onClick: () => {
      hideSetting.value = true;
      isEditProfileBoxShow.value = true;
    },
  },
  allowType: {
    value: "allowType",
    label: "加我为好友时",
    selectedChild: "",
    childrenShowType: "bottomPopup",
    showChildren: false,
    onClick: (item: any) => {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {},
  },
  displayMessageReadReceipt: {
    value: "displayMessageReadReceipt",
    label: "消息阅读状态",
    selectedChild: "userLevelReadReceiptOpen",
    childrenShowType: "bottomPopup",
    showChildren: false,
    onClick(item: any) {
      if (!isPC) {
        item.showChildren = true;
      }
    },
    children: {},
  },
  about: {
    value: "about",
    label: "关于腾讯云IM",
    selectedChild: "",
    childrenShowType: "bottomPopup",
    showChildren: false,
    children: {},
    onClick: () => {
      hideSetting.value = true;
      isAboutBoxShow.value = true;
    },
  },
  exit: {
    value: "exit",
    label: "退出登录",
    onClick: () => {
      localStorage.removeItem("MYTUIKit-userID");
      localStorage.removeItem("MYTUIKit-userSig");
      TUILogin.logout().then(() => {
        router.push({path: "/"});
      });
    },
  },
});

const handleSettingListItemOnClick = (item: any) => {
  if (item?.onClick && typeof item?.onClick === "function") {
    item.onClick(item);
  }
};

const closeAboutBox = () => {
  isAboutBoxShow.value = false;
  emits("toggleSettingShow", false);
};

const closeEditProfileBox = () => {
  isEditProfileBoxShow.value = false;
  emits("toggleSettingShow", false);
};

const updateMyProfile = (props: object) => {
  TUIUserService.updateMyProfile(props)
      .then((res: any) => {
        Toast({
          message: "更新用户资料成功",
          type: TOAST_TYPE.SUCCESS,
        });
      })
      .catch((err: any) => {
        console.warn("更新用户资料失败", err);
        Toast({
          message: "更新用户资料失败",
          type: TOAST_TYPE.ERROR,
        });
      });
};

TUIStore.watch(StoreName.USER, {
  userProfile: (userProfileData: IUserProfile) => {
    userProfile.value = deepCopy(userProfileData);
    if (userProfile?.value?.allowType) {
      settingList.value.allowType.selectedChild = userProfile?.value?.allowType;
    }
  },
  displayMessageReadReceipt(isDisplay: boolean) {
    settingList.value.displayMessageReadReceipt.selectedChild
        = isDisplay ? "userLevelReadReceiptOpen" : "userLevelReadReceiptClose";
  }
});

// pc端
// 处理 setting 点击外部关闭
// click outside
let clickOutside = false;
let clickInner = false;
const onClickOutside = (component: any) => {
  document.addEventListener("mousedown", onClickDocument);
  component?.addEventListener && component?.addEventListener("mousedown", onClickTarget);
};
const onClickDocument = () => {
  clickOutside = true;
  if (!clickInner && clickOutside) {
    emits("toggleSettingShow", false);
    removeClickListener(settingDomRef.value);
  }
  clickOutside = false;
  clickInner = false;
};
const onClickTarget = () => {
  clickInner = true;
};
const removeClickListener = (component: any) => {
  document.removeEventListener("mousedown", onClickDocument);
  component?.removeEventListener && component?.removeEventListener("mousedown", onClickTarget);
};

watch(
    () => props.showSetting,
    (newVal: any, oldVal: any) => {
      if (isPC && newVal && !oldVal) {
        nextTick(() => {
          onClickOutside(settingDomRef.value);
        });
      }
    },
    {
      immediate: true,
    }
);

// 规避TUIStore.watch userProfile 登录后暂时不能及时触发更新
onMounted(() => {
  // 查询自己的资料
  TUIUserService.getUserProfile().then((res: any) => {
    userProfile.value = res.data;
  });
});

function switchEnableUserLevelReadReceipt(status: boolean) {
  TUIStore.update(StoreName.USER, "displayMessageReadReceipt", status);
}

return { __sfc: true,props, emits, settingDomRef, userProfile, isAboutBoxShow, isEditProfileBoxShow, hideSetting, settingList, handleSettingListItemOnClick, closeAboutBox, closeEditProfileBox, updateMyProfile, clickOutside, clickInner, onClickOutside, onClickDocument, onClickTarget, removeClickListener, switchEnableUserLevelReadReceipt, TUITranslateService, BottomPopup, Icon, AboutDialog, EditProfileDialog, rightArrowIcon, selectedIcon, isPC }
}

})